import React from 'react';
import { Button, Typography, styled } from '@mui/material';

export const FormButton = ({ id, label, onClick, disabled, className, ...props }) => {
  return (
    <Button
      variant="outlined"
      aria-label={label}
      onClick={onClick}
      id={id}
      disabled={disabled}
      {...props}
      className={'myOdu__button ' + (className ? className : '')}
    >
      {label}
    </Button>
  );
};
